import { takeLatest, call, put, all, select } from 'redux-saga/effects';

import Selectors from './blacklist-selectors.js';
import Actions from './blacklist-actions';
import Api from './blacklist-api';
import Model from './blacklist-model';

function* saveBlacklistHandler() {
  const blacklist = yield select(Selectors.blacklist);

  const response = yield call(Api.updateBlacklist, blacklist);
  if (response.error) yield put(Actions.saveBlacklistFailure(response.error));
  else yield put(Actions.saveBlacklistSuccess(response));
}

//Once this one develops a bit more we will no longer pass down only the blacklistDictionary,but many more entities
function* bootstrapBlacklistHandler({ payload: blacklist }) {
  yield put(Actions.saveBlacklistSuccess(Model.deserialize(blacklist)));
}

function* blacklistSagas() {
  yield all([
    takeLatest(Actions.saveBlacklist.getType(), saveBlacklistHandler),
    takeLatest(Actions.bootstrapBlacklist.getType(), bootstrapBlacklistHandler),
  ]);
}

export default blacklistSagas;
